import merge from 'lodash/merge';
/**
 * Openlayers calls the `window` object as soon as it's imported.
 * This causes a `window undefined` error when the component is being server rendered.
 * The following workaround basically defers the import and returns a null if any errors are caught.
 */

/* eslint-disable global-require */

var openlayersProxy = new Promise(resolve => {
  try {
    var openlayers = {
      Map: require('ol/map').default,
      View: require('ol/view').default,
      Overlay: require('ol/overlay').default,
      Feature: require('ol/feature').default,
      interaction: require('ol/interaction').default,
      proj: require('ol/proj').default
    };
    merge(openlayers, {
      geom: {
        Point: require('ol/geom/point').default
      },
      proj: {
        Projection: require('ol/proj/projection').default
      },
      layer: {
        Group: require('ol/layer/group').default,
        Tile: require('ol/layer/tile').default,
        Vector: require('ol/layer/vector').default
      },
      source: {
        TileWMS: require('ol/source/tilewms').default,
        Vector: require('ol/source/vector').default
      },
      style: {
        Style: require('ol/style/style').default,
        Icon: require('ol/style/icon').default
      },
      tilegrid: {
        TileGrid: require('ol/tilegrid/tilegrid').default
      }
    });
    resolve(openlayers);
  } catch (error) {
    resolve(null);
  }
});
export default openlayersProxy;